<template>
  <div>
    <div class="vx-row justify-center">
      <div class="vx-col w-full">
        <vs-card>
          <div slot="header">
            <h3>Ubah Data Pengguna</h3>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="text"
                icon-after="true"
                icon-pack="feather"
                icon="icon-user"
                placeholder="Nama Lengkap"
                class="w-full"
                v-model="user.name"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="text"
                icon-after="true"
                icon-pack="feather"
                icon="icon-map"
                placeholder="Alamat"
                class="w-full"
                v-model="user.address"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="number"
                icon-after="true"
                icon-pack="feather"
                icon="icon-phone"
                placeholder="No. Telepon"
                class="w-full"
                v-model="user.phone"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <v-select
                placeholder="Jenis Kelamin"
                :options="sex"
                v-model="user.sex"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <v-select
                placeholder="Status"
                :options="list_status"
                v-model="user.is_active"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                icon-after="true"
                icon-pack="feather"
                icon="icon-mail"
                placeholder="Email"
                class="w-full"
                disabled
                v-model="user.authentication.email"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="password"
                icon-after="true"
                icon-pack="feather"
                icon="icon-user"
                placeholder="Password"
                class="w-full"
                v-model="user.password"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="password"
                icon-after="true"
                icon-pack="feather"
                icon="icon-user"
                placeholder="Konfirmasi Password"
                class="w-full"
                v-model="user.password_confirmation"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <v-select
                placeholder="Role"
                :options="userRoles"
                v-model="user.role"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
          </div>
          <!-- <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                @on-success="successUpload()"
              />
            </div>
          </div> -->
          <div class="vx-row mb-3">
            <div class="vx-row w-full">
              <div class="flex flex-row">
                <vs-button
                  @click="updateData"
                  class="ml-8 w-1/2"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-send"
                  type="filled"
                >Simpan</vs-button>
                <vs-button
                  @click="$router.push({name: 'users-detail', params: {id: user.id }})"
                  class="ml-3 w-1/2"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-arrow-left"
                  type="border"
                >Kembali</vs-button>
              </div>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      user: {
        id: '',
        name: "",
        phone: "",
        address: "",
        authentication: {
          email: ""
        },
        role: { id: "", label: "" },
        sex: { id: "", label: "" },
        is_active: { id: "", label: "" },
        avatar: null,
        password: "",
        password_confirmation: ""
      },
      sex: [
        { id: "L", label: "Laki-laki" },
        { id: "P", label: "Perempuan" }
      ],
      list_status: [
        { id: 1, label: "Aktif" },
        { id: 0, label: "Tidak Aktif" }
      ]
    };
  },
  mounted() {
    this.fetchUserDetail();
  },
  methods: {
    fetchUserDetail() {
      this.$vs.loading();
      this.$http
        .get(`/app/secure/user/${this.$route.params.id}`)
        .then(r => {
          for (let item of Object.keys(r.data.data.user)) {
            if (item == "sex") {
              this.user[item] = {
                id: r.data.data.user[item],
                label: r.data.data.user[item] == "L" ? "Laki-laki" : "Perempuan"
              };
            } else if (item == "role") {
              this.user[item] = {
                id: r.data.data.user[item],
                label: this.parseRole(r.data.data.user[item])
              };
            }
            else if (item == "authentication") {
              this.user['is_active'] = {
                id: r.data.data.user['authentication']['is_active'],
                label: r.data.data.user['authentication']['is_active'] ? "Aktif" : "Tidak Aktif"
              };
            } 
            else {
              this.user[item] = r.data.data.user[item];
            }
          }
        })
        .catch(e => {
          this.$vs.notify({
            title: "Error",
            text: e,
            color: "warning"
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    parseRole(id) {
      let role = this.userRoles.find(item => {
        return item.id == id;
      });
      return role.label;
    },
    updateData() {
      this.$vs.loading();
      this.$http
        .put(`/app/secure/user/${this.$route.params.id}`, {
          name: this.user.name,
          phone: this.user.phone,
          address: this.user.address,
          role: this.user.role.id,
          avatar: this.user.avatar,
          password: this.user.password,
          password_confirmation: this.user.password_confirmation,
          sex: this.user.sex.id,
          is_active: this.user.is_active.id
        })
        .then(() => {
          this.$vs.notify({
            title: "Sukses",
            text: "Berhasil menyimpan data pengguna.",
            color: "success",
            position: "top-right"
          });
          this.fetchUserDetail();
        })
        .catch(e => {
          this.$vs.notify({
            title: "Error",
            text: e,
            color: "warning"
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  },
  computed: {
    ...mapGetters(["userRoles"])
  },
  components: {
    "v-select": vSelect
  }
};
</script>